<template>
    <div class="text-center mt-5">
        <h1>{{ title }}</h1>
        <div v-if="message">{{ message }}</div>
        <div v-else>{{ description }}</div>
    </div>
</template>

<script>
import { getTemplateId } from '../../utils';

import Template1 from '../Shared/Layouts/Template1.vue';
import Template2 from '../Shared/Layouts/Template2.vue';

export default {

    layout: getTemplateId() == 1 ? Template1 : Template2,

    props: {

        status: {

            type: Number,
            required: true,

        },

        message: {

            type: String,
            required: false,

        },

    },

    mounted() {

        $('#main-body').removeClass('gray-background');

        // Sesión
        if (this.status == 419) {

            window.location.href = '/';

        }

    },

    computed: {

        title() {

            return {
                503: '503: Servicio no disponible',
                500: '500: Server Error',
                404: '404: Página no encontrada',
                403: '403: Prohibido',
            }[this.status];

        },

        description() {

            return {
                503: 'Lo sentimos, en este momento nos encontramos realizando mantenimiento. Por favor intentalo mas tarde.',
                500: 'Lo sentimos, algo salió mal en la solicitud realizada.',
                404: 'La página que está buscando no se pudo encontrar.',
                403: 'No tienes acceso a esta página.',
            }[this.status];

        },

    },
};
</script>
